export default {
  tabletMax: 992,
  boostrapBreakPoints: [576, 768, 992, 1200, 1400],
  rotatorSpeed: 900,
  rotatorTimeout: 6500,
  siteDomains: [window.location.host, 'redlakeelectric.local', 'redlakeelectric.com'],
};
